import React from "react";
import { ArrowUpRight, Navigation, ShieldCheck } from "lucide-react";
import { ACTIVE_LOCATIONS, BRAND } from "../../lib/constants";

export const LocationsHub = () => {
  const single = ACTIVE_LOCATIONS.length === 1;

  return (
    <section id="locations" className="relative py-24 sm:py-32 bg-white" data-testid="locations-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-12 gap-10 mb-16 items-end">
          <div className="md:col-span-7">
            <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-5">
              {single ? "Our Flagship · Now Open" : "Three Locations · One Standard"}
            </div>
            <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              DWC on <em className="text-brand">Georgia Ave</em>.
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-ink-muted text-base leading-relaxed">
              {single
                ? "Our flagship dispensary at 4915 Georgia Ave NW is open and serving Washington, DC patients. Walk in, or order ahead for fast pickup."
                : "Uptown on Georgia Ave, Midtown by Howard University, and Downtown at Dupont Circle. Same menu. Same standard."}
            </p>
            <div className="mt-5 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-ink-muted">
              <ShieldCheck size={14} className="text-brand" /> Licensed by DC ABCA · License {BRAND.licenseNumber}
            </div>
          </div>
        </div>

        <div className={`grid gap-6 ${single ? "md:grid-cols-1" : "md:grid-cols-3"}`}>
          {ACTIVE_LOCATIONS.map((loc) => (
            <article
              key={loc.id}
              className="group relative border border-black/10 bg-white hover:bg-ink hover:text-white transition-colors duration-500"
              data-testid={`location-card-${loc.id}`}
            >
              <div className={`p-8 ${single ? "sm:p-12 grid md:grid-cols-12 gap-8 items-center" : "flex flex-col h-full"}`}>
                <div className={single ? "md:col-span-7" : ""}>
                  <div className="flex items-center justify-between mb-6">
                    <div className="text-[10px] uppercase tracking-[0.3em] text-brand">{loc.label}</div>
                    <span className="text-[10px] uppercase tracking-[0.25em] px-2.5 py-1 bg-brand text-white" data-testid={`location-status-${loc.id}`}>
                      Open Now
                    </span>
                  </div>

                  <h3 className={`font-serif leading-tight mb-4 ${single ? "text-4xl sm:text-5xl" : "text-3xl"}`}>{loc.name}</h3>

                  <div className="mb-5">
                    <div className={`font-medium ${single ? "text-2xl" : "text-lg"}`}>{loc.street}</div>
                    <div className="text-base text-ink-muted group-hover:text-white/60">{loc.city}</div>
                    {loc.phone && (
                      <a href={loc.phoneHref} className="mt-3 inline-flex items-center gap-2 text-base text-ink-muted group-hover:text-brand" data-testid={`location-phone-${loc.id}`}>
                        <span className="text-brand">☎</span> {loc.phone}
                      </a>
                    )}
                  </div>

                  <p className="text-base leading-relaxed text-ink-muted group-hover:text-white/70 mb-6">
                    {loc.blurb}
                  </p>
                </div>

                <div className={single ? "md:col-span-5" : ""}>
                  <div className={`pt-5 border-t border-black/10 group-hover:border-white/15 ${single ? "" : "flex items-center justify-between"}`}>
                    <div className="text-[11px] uppercase tracking-[0.2em] text-ink-muted group-hover:text-white/60 mb-3">
                      {loc.hours}
                    </div>
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(loc.mapQuery)}`}
                      target="_blank" rel="noreferrer"
                      className="inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.2em] group-hover:text-brand"
                      data-testid={`location-directions-${loc.id}`}
                    >
                      <Navigation size={12} /> Get Directions
                    </a>
                  </div>

                  <a
                    href="/menu"
                    className="mt-6 inline-flex items-center justify-between w-full px-5 py-4 bg-ink group-hover:bg-brand text-white text-[11px] uppercase tracking-[0.22em] transition-colors"
                    data-testid={`location-order-${loc.id}`}
                  >
                    Order from this store <ArrowUpRight size={14} />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationsHub;
